<div class="modal-content">
  <div class="title-page"><h3 class="form-title text-center">Validar e-mail</h3></div>
    <form class="p-5" [formGroup]="formToken">

      <div class="form-row d-flex justify-content-center">
        <div class="icon-email">
          <span class="material-icons-outlined">
            mail
          </span>
        </div>
      </div>
      <div class="form-row">
        <h3 class="subtitle-form text-center col-12">Enviamos um código de verificação para</h3>
      </div>
      <div class="form-row mt-2">
        <div class="col-md">
          <h3 class="title-email">
            <p><b>{{ emailMascarado }}</b></p>
          </h3>
        </div>
      </div>
      <div class="form-row mt-4">
        <div class="col-md">
          <h3 class="info-email">
            Digite o código de 6 dígitos abaixo:
          </h3>
        </div>
      </div>

       <div>
          <app-token-input
          [formControl]="tokenFornecido"
          [status]="tokenStatus"
          [resendSeconds]="60"
          (resend)="enviarTokenEmail()"
          >
          </app-token-input>
        </div>

      <div class="form-row mt-5 d-flex justify-content-center">
        <div class="col-md-4 d-flex justify-content-center">
          <button (click)="close()" type="button" class="btn-voltar">
            <i class="fas fa-arrow-left"></i>
            Voltar
          </button>
        </div>
        <div class="col-md-4 d-flex justify-content-center">
          <button data-testid="botao-validar-email" class="btn" (click)="validateEmail()">Validar e-mail</button>
        </div>
      </div>
    </form>
</div>
